import { render, staticRenderFns } from "./IconPlayNoCircle.vue?vue&type=template&id=0bc6dcde&scoped=true"
import script from "./IconPlayNoCircle.vue?vue&type=script&lang=js"
export * from "./IconPlayNoCircle.vue?vue&type=script&lang=js"
import style0 from "./IconPlayNoCircle.vue?vue&type=style&index=0&id=0bc6dcde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc6dcde",
  null
  
)

export default component.exports